/**
 * Reported issues (O-49 triage inbox) for the Data portal.
 *
 * Mount: spread `dataIssueRoutes` into `DATA_EXPLORER_ROUTES` in `App.tsx`
 * (same `[path, LazyComponent]` tuples) and add the "Reported issues" tool
 * link pointing at `DATA_ISSUES_PATH`. Data admins see every report; everyone
 * else sees their own ("My reports"). The API enforces both.
 */
import React, { lazy } from 'react';
import { DATA_ISSUES_PATH } from '../reportIssue.js';

export { DATA_ISSUES_PATH } from '../reportIssue.js';
export const DATA_ISSUES_NAV_LABEL = 'Reported issues';

export const dataIssueRoutes: Array<[string, React.LazyExoticComponent<React.FC>]> = [
  [DATA_ISSUES_PATH, lazy(() => import('./IssuesPage.js'))],
  [`${DATA_ISSUES_PATH}/:issueId`, lazy(() => import('./IssueDetailPage.js'))],
];
